import { IconEye, IconEyeOff } from "@tabler/icons-react";
import React, { useState } from "react";
import { UseFormRegister, FieldError, RegisterOptions } from "react-hook-form";
import { useLanguage } from "../context/LanguageContext";

interface InputProps {
  name: string;
  type?: string;
  title?: string;
  placeholder?: string;
  register?: UseFormRegister<any>; // You can replace `any` with your form type
  validation?: RegisterOptions;
  error?: FieldError | any;
  other?: any;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
  removeDiv?: boolean;
  step?: any;
  inputMode?: any;
  inputClassName?: any;
  min?: any;
  max?: any;
  maxLength?: number;
}

const NewinputField: React.FC<InputProps> = ({
  name,
  title,
  type,
  placeholder = "",
  register,
  validation,
  error,
  other,
  className = "space-y-1",
  labelClass = "",
  removeDiv = false,
  disabled = false,
  defaultValue = "",
  value,
  step,
  inputMode,
  inputClassName,
  min,
  max,
  maxLength,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useLanguage();

  const inputField = (
    <input
      type={type === "password" && showPassword ? "text" : type}
      placeholder={t(placeholder)}
      className={
        inputClassName
          ? inputClassName
          : `w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] 
       ${type === "number" ? "hide-spinner" : ""} 
       disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed`
      }
      defaultValue={defaultValue}
      value={value}
      {...(register ? register(name, validation) : {})}
      {...other}
      disabled={disabled}
      {...(step !== undefined ? { step } : {})}
      {...(inputMode !== undefined ? { inputMode } : {})}
      autoComplete="off"
      onKeyDown={(e) => {
        if (type === "number" && ["e", "E", "+", "-"].includes(e.key)) {
          e.preventDefault();
        }
        if (other?.onKeyDown) {
          other.onKeyDown(e);
        }
      }}
      min={min}
      max={max}
      {...(maxLength !== undefined ? { maxLength } : {})}
    />
  );

  return (
    <div className={` ${className}`}>
      {title && (
        <label
          className={`text-[#1E293B] text-xs ${labelClass || "whitespace-nowrap"}`}
        >
          {t(title)}
          {validation?.required && <span className="text-red-600 ">*</span>}
        </label>
      )}
      <div className="w-full flex-1 min-w-0">
        {!removeDiv ? (
          <div className="relative">
            {inputField}
            {type === "password" && (
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/4 text-gray-500"
              >
                {showPassword ? (
                  <IconEyeOff size={18} />
                ) : (
                  <IconEye size={18} />
                )}
              </button>
            )}
          </div>
        ) : (
          inputField
        )}
        {error &&
          (error?.message?.includes("\n") ? (
            error?.message?.split("\n").map((line: string, index: number) => (
              <span
                key={`val${index + 1}`}
                className="block text-red-500 text-xs px-3"
              >
                {t(line)}
              </span>
            ))
          ) : (
            <span className="text-red-500 text-xs min-h-[0.5rem] block  ">
              {error?.message ? t(error.message) : ""}
            </span>
          ))}
      </div>
    </div>
  );
};

export default NewinputField;
